/**
 * Xvelo Order Tracking Page
 * - i18n multi-language support (EN, DE, FR, NL)
 * - Guest lookup (tracking # or order ID)
 * - Authenticated order display
 * - Real-time tracking via 17Track API
 */

(function() {
  'use strict';

  // ─── i18n TRANSLATIONS ───────────────────────────────────────────────
  const i18n = {
    en: {
      promo: 'Spring Riding Season',
      promo_sub: 'Up to 30% off · Free shipping across Europe',
      nav_home: 'Home',
      nav_products: 'Products',
      nav_orders: 'My Orders',
      nav_contact: 'Contact',
      guest_h1_1: 'Track your ',
      guest_h1_2: 'order',
      guest_sub: 'Enter your tracking number or order ID to see real-time shipment updates.',
      tab_tracking: 'Tracking Number',
      tab_order: 'Order ID',
      lbl_carrier: 'Carrier',
      lbl_tracking: 'Tracking Number',
      lbl_order: 'Order Number',
      lbl_email: 'Order Email',
      ph_tracking: 'e.g. 1Z999AA10123456784',
      ph_order: 'e.g. #XV-10293',
      ph_email: 'email@example.com',
      hint_tracking: 'Found on your order confirmation email',
      hint_order: 'Check your order confirmation email',
      btn_track: 'Track Shipment',
      or_text: 'or',
      login_prompt_text: 'Have an account? ',
      login_prompt_link: 'Sign in to see all orders automatically.',
      login_btn: 'Sign in',
      hi: 'Hi',
      your: 'your',
      orders_word: 'orders',
      active_ship: 'Active shipments',
      delivered_word: 'Delivered',
      exception_word: 'Needs attention',
      all_delivered_title_1: 'All ',
      all_delivered_title_2: 'delivered!',
      all_delivered_sub: 'All your orders have arrived. Ready for your next ride?',
      shop_new: 'Shop new arrivals',
      view_acc: 'View accessories',
      recommended: 'Recommended for you',
      order_history: 'Order history',
      notify_title: 'Notification preferences',
      notify_sub: 'Stay updated on your shipment status changes.',
      notify_email: 'Email notifications',
      notify_email_sub: 'Get updates in your inbox',
      notify_sms: 'SMS notifications',
      notify_sms_sub: 'Real-time text alerts',
      notify_push: 'Push notifications',
      notify_push_sub: 'Browser alerts when status changes',
      help: 'Need help?',
      contact_support: 'Contact support',
      leave_review: 'Leave a review',
      buy_again: 'Buy again',
      btn_notify: 'Notify me',
      btn_chat: 'Chat with us',
      btn_invoice: 'Invoice',
      btn_reorder: 'Re-order',
      btn_escalate: 'Escalate',
      show_history: 'Show full history ▾',
      hide_history: 'Hide history ▴',
      back: '← Back to search',
      est_delivery: 'Estimated delivery',
      arriving_today: 'Arriving today!',
      arriving_tomorrow: 'Arriving tomorrow!',
      days_left: ' days away',
      delayed_warning: 'Delayed — new estimate: ',
      carrier_any: 'Auto-detect carrier',
      placed: 'Placed',
      status_transit: 'In Transit',
      status_customs: 'Customs Clearance',
      status_pending: 'Processing',
      status_delivered: 'Delivered',
      status_delayed: 'Delayed',
      status_exception: 'Action Required',
      status_returned: 'Returned',
      alert_customs: 'Your package is clearing EU customs. This typically takes 12–24h. No action needed — we handle all import documentation and duties.',
      alert_delayed: 'Your shipment is experiencing delays at Frankfurt customs due to additional documentation checks. Updated delivery estimate provided above. We are working to resolve this quickly.',
      alert_exception: 'A delivery attempt failed — no one was available to sign. Please <a>schedule a re-delivery</a> or <a>choose a pickup point</a> within 5 business days to avoid return to sender.',
      alert_return: 'This package is being returned to sender due to an incorrect address. Please <a>contact support</a> to arrange re-shipment.',
      error_not_found: 'Tracking number not found. Please check and try again.',
      error_invalid_order: 'No order found for this email/order combination.',
      loading_orders: 'Loading your orders...'
    },
    de: {
      promo: 'Frühlings-Radsaison',
      promo_sub: 'Bis zu 30% Rabatt · Kostenloser Versand in Europa',
      nav_home: 'Startseite',
      nav_products: 'Produkte',
      nav_orders: 'Meine Bestellungen',
      nav_contact: 'Kontakt',
      guest_h1_1: 'Verfolgen Sie Ihre ',
      guest_h1_2: 'Bestellung',
      guest_sub: 'Geben Sie Ihre Sendungsnummer oder Bestellnummer ein, um den Echtzeit-Versandstatus zu sehen.',
      tab_tracking: 'Sendungsnummer',
      tab_order: 'Bestellnummer',
      lbl_carrier: 'Versanddienstleister',
      lbl_tracking: 'Sendungsnummer',
      lbl_order: 'Bestellnummer',
      lbl_email: 'Bestell-E-Mail',
      ph_tracking: 'z.B. 1Z999AA10123456784',
      ph_order: 'z.B. #XV-10293',
      ph_email: 'email@beispiel.de',
      hint_tracking: 'In Ihrer Bestellbestätigungs-E-Mail zu finden',
      hint_order: 'Prüfen Sie Ihre Bestellbestätigungs-E-Mail',
      btn_track: 'Sendung verfolgen',
      or_text: 'oder',
      login_prompt_text: 'Haben Sie ein Konto? ',
      login_prompt_link: 'Anmelden, um alle Bestellungen zu sehen.',
      login_btn: 'Anmelden',
      hi: 'Hallo',
      your: 'Ihre',
      orders_word: 'Bestellungen',
      active_ship: 'Aktive Sendungen',
      delivered_word: 'Zugestellt',
      exception_word: 'Erfordert Aufmerksamkeit',
      all_delivered_title_1: 'Alle ',
      all_delivered_title_2: 'zugestellt!',
      all_delivered_sub: 'Alle Ihre Bestellungen sind angekommen. Bereit für Ihre nächste Fahrt?',
      shop_new: 'Neuheiten entdecken',
      view_acc: 'Zubehör ansehen',
      recommended: 'Empfohlen für Sie',
      order_history: 'Bestellverlauf',
      notify_title: 'Benachrichtigungseinstellungen',
      notify_sub: 'Bleiben Sie über Statusänderungen informiert.',
      notify_email: 'E-Mail-Benachrichtigungen',
      notify_email_sub: 'Updates in Ihrem Posteingang',
      notify_sms: 'SMS-Benachrichtigungen',
      notify_sms_sub: 'Echtzeit-SMS-Benachrichtigungen',
      notify_push: 'Push-Benachrichtigungen',
      notify_push_sub: 'Browser-Benachrichtigungen bei Statusänderungen',
      help: 'Brauchen Sie Hilfe?',
      contact_support: 'Support kontaktieren',
      leave_review: 'Bewertung abgeben',
      buy_again: 'Nochmal kaufen',
      btn_notify: 'Benachrichtigen',
      btn_chat: 'Chat starten',
      btn_invoice: 'Rechnung',
      btn_reorder: 'Nachbestellen',
      btn_escalate: 'Eskalieren',
      show_history: 'Verlauf anzeigen ▾',
      hide_history: 'Verlauf ausblenden ▴',
      back: '← Zurück zur Suche',
      est_delivery: 'Voraussichtliche Lieferung',
      arriving_today: 'Lieferung heute!',
      arriving_tomorrow: 'Lieferung morgen!',
      days_left: ' Tage',
      delayed_warning: 'Verzögert — neue Schätzung: ',
      carrier_any: 'Automatisch erkennen',
      placed: 'Bestellt am',
      status_transit: 'Unterwegs',
      status_customs: 'Zollabfertigung',
      status_pending: 'In Bearbeitung',
      status_delivered: 'Zugestellt',
      status_delayed: 'Verzögert',
      status_exception: 'Aktion erforderlich',
      status_returned: 'Zurückgesendet',
      alert_customs: 'Ihr Paket wird beim EU-Zoll abgefertigt. Dies dauert in der Regel 12–24 Stunden. Keine Aktion erforderlich — wir kümmern uns um alle Importdokumente.',
      alert_delayed: 'Ihre Sendung erfährt Verzögerungen beim Frankfurter Zoll aufgrund zusätzlicher Dokumentenprüfungen. Aktualisierte Lieferschätzung siehe oben.',
      alert_exception: 'Ein Zustellversuch ist fehlgeschlagen. Bitte <a>vereinbaren Sie eine Neuzustellung</a> oder <a>wählen Sie eine Abholstelle</a> innerhalb von 5 Werktagen.',
      alert_return: 'Dieses Paket wird aufgrund einer falschen Adresse an den Absender zurückgeschickt. Bitte <a>kontaktieren Sie den Support</a>.',
      error_not_found: 'Sendungsnummer nicht gefunden. Bitte überprüfen und erneut versuchen.',
      error_invalid_order: 'Keine Bestellung für diese E-Mail/Bestellnummer-Kombination gefunden.',
      loading_orders: 'Lade Ihre Bestellungen...'
    },
    fr: {
      promo: 'Saison Cycliste Printemps',
      promo_sub: "Jusqu'à -30% · Livraison gratuite en Europe",
      nav_home: 'Accueil',
      nav_products: 'Produits',
      nav_orders: 'Mes Commandes',
      nav_contact: 'Contact',
      guest_h1_1: 'Suivez votre ',
      guest_h1_2: 'commande',
      guest_sub: 'Entrez votre numéro de suivi ou de commande pour voir les mises à jour en temps réel.',
      tab_tracking: 'N° de suivi',
      tab_order: 'N° de commande',
      lbl_carrier: 'Transporteur',
      lbl_tracking: 'Numéro de suivi',
      lbl_order: 'Numéro de commande',
      lbl_email: 'Email de commande',
      ph_tracking: 'ex: 1Z999AA10123456784',
      ph_order: 'ex: #XV-10293',
      ph_email: 'email@exemple.fr',
      hint_tracking: 'Trouvé dans votre email de confirmation',
      hint_order: 'Vérifiez votre email de confirmation',
      btn_track: 'Suivre le colis',
      or_text: 'ou',
      login_prompt_text: 'Vous avez un compte ? ',
      login_prompt_link: 'Connectez-vous pour voir toutes vos commandes.',
      login_btn: 'Connexion',
      hi: 'Bonjour',
      your: 'vos',
      orders_word: 'commandes',
      active_ship: 'Envois actifs',
      delivered_word: 'Livré',
      exception_word: 'Action requise',
      all_delivered_title_1: 'Tout est ',
      all_delivered_title_2: 'livré !',
      all_delivered_sub: 'Toutes vos commandes sont arrivées. Prêt pour votre prochaine balade ?',
      shop_new: 'Découvrir les nouveautés',
      view_acc: 'Voir les accessoires',
      recommended: 'Recommandé pour vous',
      order_history: 'Historique',
      notify_title: 'Préférences de notification',
      notify_sub: 'Restez informé des changements de statut.',
      notify_email: 'Notifications email',
      notify_email_sub: 'Mises à jour dans votre boîte mail',
      notify_sms: 'Notifications SMS',
      notify_sms_sub: 'Alertes en temps réel par SMS',
      notify_push: 'Notifications push',
      notify_push_sub: 'Alertes navigateur lors des changements',
      help: "Besoin d'aide ?",
      contact_support: 'Contacter le support',
      leave_review: 'Laisser un avis',
      buy_again: 'Racheter',
      btn_notify: 'Me prévenir',
      btn_chat: 'Discuter',
      btn_invoice: 'Facture',
      btn_reorder: 'Commander à nouveau',
      btn_escalate: 'Escalader',
      show_history: "Voir l'historique ▾",
      hide_history: "Masquer l'historique ▴",
      back: '← Retour à la recherche',
      est_delivery: 'Livraison estimée',
      arriving_today: "Livraison aujourd'hui !",
      arriving_tomorrow: 'Livraison demain !',
      days_left: ' jours',
      delayed_warning: 'Retardé — nouvelle estimation : ',
      carrier_any: 'Détection automatique',
      placed: 'Commandé le',
      status_transit: 'En transit',
      status_customs: 'Dédouanement',
      status_pending: 'En traitement',
      status_delivered: 'Livré',
      status_delayed: 'Retardé',
      status_exception: 'Action requise',
      status_returned: 'Retourné',
      alert_customs: 'Votre colis est en cours de dédouanement UE. Cela prend généralement 12 à 24 heures. Aucune action requise de votre part.',
      alert_delayed: 'Votre envoi subit des retards à la douane de Francfort en raison de vérifications supplémentaires. Estimation de livraison mise à jour ci-dessus.',
      alert_exception: 'Une tentative de livraison a échoué. Veuillez <a>planifier une relivraison</a> ou <a>choisir un point relais</a> sous 5 jours ouvrés.',
      alert_return: "Ce colis est retourné à l'expéditeur en raison d'une adresse incorrecte. Veuillez <a>contacter le support</a>.",
      error_not_found: 'Numéro de suivi introuvable. Veuillez vérifier et réessayer.',
      error_invalid_order: 'Aucune commande trouvée pour cette combinaison email/numéro.',
      loading_orders: 'Chargement de vos commandes...'
    },
    nl: {
      promo: 'Lente Fietsseizoen',
      promo_sub: 'Tot 30% korting · Gratis verzending in Europa',
      nav_home: 'Home',
      nav_products: 'Producten',
      nav_orders: 'Mijn Bestellingen',
      nav_contact: 'Contact',
      guest_h1_1: 'Volg je ',
      guest_h1_2: 'bestelling',
      guest_sub: 'Voer je trackingnummer of bestelnummer in om realtime verzendupdates te zien.',
      tab_tracking: 'Trackingnummer',
      tab_order: 'Bestelnummer',
      lbl_carrier: 'Vervoerder',
      lbl_tracking: 'Trackingnummer',
      lbl_order: 'Bestelnummer',
      lbl_email: 'Bestel-e-mail',
      ph_tracking: 'bijv. 1Z999AA10123456784',
      ph_order: 'bijv. #XV-10293',
      ph_email: 'email@voorbeeld.nl',
      hint_tracking: 'Te vinden in je bestelbevestigingsmail',
      hint_order: 'Controleer je bestelbevestigingsmail',
      btn_track: 'Zending volgen',
      or_text: 'of',
      login_prompt_text: 'Heb je een account? ',
      login_prompt_link: 'Log in om al je bestellingen te zien.',
      login_btn: 'Inloggen',
      hi: 'Hallo',
      your: 'je',
      orders_word: 'bestellingen',
      active_ship: 'Actieve zendingen',
      delivered_word: 'Bezorgd',
      exception_word: 'Aandacht vereist',
      all_delivered_title_1: 'Alles ',
      all_delivered_title_2: 'bezorgd!',
      all_delivered_sub: 'Al je bestellingen zijn aangekomen. Klaar voor je volgende rit?',
      shop_new: 'Nieuwe collectie',
      view_acc: 'Accessoires bekijken',
      recommended: 'Aanbevolen voor jou',
      order_history: 'Bestelgeschiedenis',
      notify_title: 'Meldingsvoorkeuren',
      notify_sub: 'Blijf op de hoogte van statuswijzigingen.',
      notify_email: 'E-mailmeldingen',
      notify_email_sub: 'Updates in je inbox',
      notify_sms: 'SMS-meldingen',
      notify_sms_sub: 'Realtime sms-meldingen',
      notify_push: 'Pushmeldingen',
      notify_push_sub: 'Browsermeldingen bij statuswijzigingen',
      help: 'Hulp nodig?',
      contact_support: 'Support contacteren',
      leave_review: 'Review achterlaten',
      buy_again: 'Opnieuw kopen',
      btn_notify: 'Melding',
      btn_chat: 'Chat met ons',
      btn_invoice: 'Factuur',
      btn_reorder: 'Opnieuw bestellen',
      btn_escalate: 'Escaleren',
      show_history: 'Geschiedenis tonen ▾',
      hide_history: 'Geschiedenis verbergen ▴',
      back: '← Terug naar zoeken',
      est_delivery: 'Geschatte levering',
      arriving_today: 'Levering vandaag!',
      arriving_tomorrow: 'Levering morgen!',
      days_left: ' dagen',
      delayed_warning: 'Vertraagd — nieuwe schatting: ',
      carrier_any: 'Automatisch detecteren',
      placed: 'Besteld op',
      status_transit: 'Onderweg',
      status_customs: 'Douane',
      status_pending: 'In behandeling',
      status_delivered: 'Bezorgd',
      status_delayed: 'Vertraagd',
      status_exception: 'Actie vereist',
      status_returned: 'Teruggestuurd',
      alert_customs: 'Je pakket wordt door de EU-douane verwerkt. Dit duurt doorgaans 12-24 uur. Geen actie nodig — wij regelen alle importdocumentatie.',
      alert_delayed: 'Je zending heeft vertraging bij de douane in Frankfurt vanwege aanvullende documentcontroles. Bijgewerkte leveringsschatting hierboven.',
      alert_exception: 'Een bezorgpoging is mislukt. <a>Plan een herbezorging</a> of <a>kies een afhaalpunt</a> binnen 5 werkdagen.',
      alert_return: 'Dit pakket wordt teruggestuurd naar de afzender vanwege een onjuist adres. Neem <a>contact op met support</a>.',
      error_not_found: 'Trackingnummer niet gevonden. Controleer en probeer opnieuw.',
      error_invalid_order: 'Geen bestelling gevonden voor deze email/bestelnummer-combinatie.',
      loading_orders: 'Je bestellingen laden...'
    }
  };

  // ─── STATE ───────────────────────────────────────────────────────────
  let currentLang = 'en';

  // ─── 17TRACK API CONFIG ─────────────────────────────────────────────
  // Cloudflare Worker proxy URL
  const TRACK_PROXY_URL = 'https://xvelo-tracking.clf971018.workers.dev';

  // ─── HELPERS ─────────────────────────────────────────────────────────
  function t(key) {
    return i18n[currentLang]?.[key] || i18n.en[key] || key;
  }

  function tl(val) {
    if (typeof val === 'object' && val !== null) {
      return val[currentLang] || val.en || '';
    }
    return val;
  }

  function detectLanguage() {
    // Priority: URL param > Shopify locale > Browser
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get('lang');
    if (urlLang && i18n[urlLang]) return urlLang;

    // Check Shopify locale from html lang attribute
    const htmlLang = document.documentElement.lang?.split('-')[0];
    if (htmlLang && i18n[htmlLang]) return htmlLang;

    // Browser language
    const browserLang = navigator.language?.split('-')[0];
    if (browserLang && i18n[browserLang]) return browserLang;

    return 'en';
  }

  function updatePageLanguage() {
    // Update all elements with data-i18n attribute
    document.querySelectorAll('[data-i18n]').forEach(el => {
      const key = el.getAttribute('data-i18n');
      el.textContent = t(key);
    });

    // Update carrier select first option
    const carrierSelect = document.querySelector('select[name="carrier"]');
    if (carrierSelect && carrierSelect.options[0]) {
      carrierSelect.options[0].textContent = t('carrier_any');
    }

    // Update language switcher display
    const flags = { en: '🇬🇧', de: '🇩🇪', fr: '🇫🇷', nl: '🇳🇱' };
    const flagEl = document.querySelector('.lang-flag');
    const codeEl = document.querySelector('.lang-code');
    if (flagEl) flagEl.textContent = flags[currentLang];
    if (codeEl) codeEl.textContent = currentLang.toUpperCase();

    // Update active state in dropdown
    document.querySelectorAll('.lang-opt').forEach(opt => {
      opt.classList.toggle('active', opt.dataset.lang === currentLang);
    });
  }

  // ─── LANGUAGE SWITCHER ───────────────────────────────────────────────
  function initLanguageSwitcher() {
    const langBtn = document.querySelector('[data-lang-toggle]');
    const dropdown = document.querySelector('.lang-dropdown');

    if (!langBtn || !dropdown) return;

    langBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      dropdown.classList.toggle('open');
    });

    document.querySelectorAll('.lang-opt').forEach(opt => {
      opt.addEventListener('click', () => {
        const lang = opt.dataset.lang;
        if (lang && i18n[lang]) {
          currentLang = lang;
          dropdown.classList.remove('open');
          updatePageLanguage();

          // Update URL without reload
          const url = new URL(window.location);
          url.searchParams.set('lang', lang);
          window.history.replaceState({}, '', url);
        }
      });
    });

    // Close dropdown on outside click
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.lang-switch')) {
        dropdown.classList.remove('open');
      }
    });
  }

  // ─── GUEST FORM SUBMISSION ───────────────────────────────────────────
  function initGuestForms() {
    // Only order lookup form (order number + email) - no direct tracking number lookup
    const orderForm = document.querySelector('[data-form="order"]');

    if (orderForm) {
      orderForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        await handleOrderLookup(orderForm);
      });
    }

    // Back to search
    const backLink = document.querySelector('[data-back-to-search]');
    if (backLink) {
      backLink.addEventListener('click', () => {
        const resultView = document.querySelector('[data-guest-result]');
        const lookupCard = document.querySelector('.lookup-card');
        const guestHero = document.querySelector('.guest-hero');

        if (resultView) resultView.style.display = 'none';
        if (lookupCard) lookupCard.style.display = 'block';
        if (guestHero) guestHero.style.display = 'block';
      });
    }
  }

  async function handleOrderLookup(form) {
    const btn = form.querySelector('.lookup-submit');
    const orderNumber = form.querySelector('input[name="order_number"]').value.trim();
    const email = form.querySelector('input[name="email"]').value.trim();

    if (!orderNumber || !email) return;

    setButtonLoading(btn, true);

    try {
      // Call Cloudflare Worker to lookup order via Shopify API
      const response = await fetch(TRACK_PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'order_lookup',
          order_number: orderNumber,
          email: email
        })
      });

      const data = await response.json();

      if (!data.found || !data.order) {
        showError(form, t('error_invalid_order'));
        return;
      }

      // Convert Shopify order to tracking display format
      const order = await convertShopifyOrderToTracking(data.order);
      showGuestResult(order);

    } catch (error) {
      console.error('Order lookup failed:', error);
      showError(form, t('error_invalid_order'));
    } finally {
      setButtonLoading(btn, false);
    }
  }

  // Convert Shopify order data to tracking display format
  async function convertShopifyOrderToTracking(shopifyOrder) {
    const fulfillment = shopifyOrder.fulfillments && shopifyOrder.fulfillments[0];
    const trackingNumber = fulfillment?.trackingNumber || fulfillment?.trackingNumbers?.[0];
    const carrier = fulfillment?.trackingCompany || 'Carrier';

    // Determine status based on fulfillment status
    let status = 'pending';
    let statusLabel = getStatusLabel('pending');

    if (shopifyOrder.fulfillmentStatus === 'fulfilled') {
      status = 'delivered';
      statusLabel = getStatusLabel('delivered');
    } else if (fulfillment) {
      status = 'transit';
      statusLabel = getStatusLabel('transit');
    }

    // If we have a tracking number, try to get real tracking info
    let trackingInfo = null;
    if (trackingNumber) {
      try {
        const response = await call17TrackAPI(trackingNumber);
        trackingInfo = parseTrackingResponseSafe(response, trackingNumber, carrier);
      } catch (e) {
        console.log('Could not fetch tracking info:', e);
      }
    }

    // If we got tracking info, use it; otherwise build basic order card
    if (trackingInfo) {
      trackingInfo.id = shopifyOrder.name;
      trackingInfo.product = shopifyOrder.lineItems.map(i => i.title).join(', ');
      trackingInfo.date = formatDate(shopifyOrder.createdAt);
      return trackingInfo;
    }

    // Build basic order card without tracking details
    const orderDate = formatDate(shopifyOrder.createdAt);
    const progress = status === 'delivered' ? 100 : (status === 'transit' ? 50 : 20);

    return {
      id: shopifyOrder.name,
      product: shopifyOrder.lineItems.map(i => i.title).join(', ').substring(0, 50) + (shopifyOrder.lineItems.length > 1 ? '...' : ''),
      date: orderDate,
      carrier: carrier,
      track: trackingNumber || 'N/A',
      status: status,
      statusLabel: statusLabel,
      eta: '',
      etaDays: null,
      progress: progress,
      progLabel: statusLabel,
      steps: [
        { t: 'Ordered', s: 'done' },
        { t: 'Shipped', s: fulfillment ? 'done' : '' },
        { t: 'In Transit', s: status === 'transit' ? 'cur' : (status === 'delivered' ? 'done' : '') },
        { t: 'Delivered', s: status === 'delivered' ? 'done' : '' }
      ],
      timeline: [
        {
          node: 'done',
          icon: '✓',
          title: { en: 'Order placed', de: 'Bestellt', fr: 'Commande passée', nl: 'Besteld' },
          time: orderDate,
          loc: ''
        },
        ...(fulfillment ? [{
          node: status === 'delivered' ? 'done' : 'active',
          icon: status === 'delivered' ? '✓' : '📦',
          title: { en: `Shipped via ${carrier}`, de: `Versandt via ${carrier}`, fr: `Expédié via ${carrier}`, nl: `Verzonden via ${carrier}` },
          time: formatDate(fulfillment.createdAt),
          loc: trackingNumber ? `Tracking: ${trackingNumber}` : ''
        }] : [])
      ]
    };
  }

  // Safe version of parseTrackingResponse that doesn't throw
  function parseTrackingResponseSafe(data, trackingNumber, carrier) {
    try {
      return parseTrackingResponse(data, trackingNumber, carrier);
    } catch (e) {
      return null;
    }
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  function setButtonLoading(btn, loading) {
    if (loading) {
      btn.classList.add('loading');
    } else {
      btn.classList.remove('loading');
    }
  }

  // ─── 17TRACK API CALL (via Cloudflare Worker) ────────────────────────
  async function call17TrackAPI(trackingNumber, carrierCode = '') {
    const payload = {
      tracking_number: trackingNumber,
      carrier_code: carrierCode ? parseInt(carrierCode) : undefined
    };

    try {
      const response = await fetch(TRACK_PROXY_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('17Track API error:', error);
      throw error;
    }
  }

  // Carrier code mapping for 17Track
  const CARRIER_CODES = {
    'dhl': 100001,      // DHL Express
    'dpd': 100045,      // DPD
    'postnl': 100016,   // PostNL
    'ups': 100002,      // UPS
    'fedex': 100003,    // FedEx
    'gls': 100050       // GLS
  };

  function parseTrackingResponse(data, trackingNumber, carrier) {
    // Check API response structure
    if (!data || !data.data) {
      throw new Error('Invalid API response');
    }

    // Check if tracking number was rejected
    if (data.data.rejected && data.data.rejected.length > 0) {
      throw new Error('Tracking number not found');
    }

    // Check if accepted array has data
    if (!data.data.accepted || data.data.accepted.length === 0) {
      throw new Error('No tracking info found');
    }

    const trackInfo = data.data.accepted[0];
    const track = trackInfo.track;

    // Check if track data exists and has events
    if (!track || !track.z0 || track.z0.length === 0) {
      throw new Error('No tracking events found');
    }

    // Check status code - 0 means not found/not yet in system
    if (track.e === 0) {
      throw new Error('Tracking number not yet in carrier system');
    }

    // Parse status
    const statusMap = {
      10: 'transit',     // In transit
      20: 'expired',     // Expired
      30: 'pickup',      // Ready for pickup
      35: 'undelivered', // Undelivered
      40: 'delivered',   // Delivered
      50: 'exception'    // Alert/Exception
    };

    const status = statusMap[track.e] || 'transit';
    const isDelivered = status === 'delivered';

    // Parse events
    const events = track.z0 || [];
    const timeline = events.slice(0, 10).map((event, idx) => {
      const isFirst = idx === 0;
      return {
        node: isFirst ? (isDelivered ? 'done' : 'active') : 'done',
        icon: isFirst ? (isDelivered ? '✓' : '📦') : '✓',
        title: { en: event.z, de: event.z, fr: event.z, nl: event.z },
        time: formatEventTime(event.a),
        loc: event.c || ''
      };
    });

    // Calculate ETA
    let eta = '';
    let etaDays = null;
    if (!isDelivered && track.z2) {
      const etaDate = new Date(track.z2);
      const today = new Date();
      etaDays = Math.ceil((etaDate - today) / (1000 * 60 * 60 * 24));
      eta = etaDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    }

    // Build progress steps
    const progress = isDelivered ? 100 : Math.min(Math.max((events.length / 6) * 100, 20), 90);
    const steps = [
      { t: 'Ordered', s: 'done' },
      { t: 'Shipped', s: events.length >= 1 ? 'done' : '' },
      { t: 'In Transit', s: events.length >= 2 ? 'done' : (events.length >= 1 ? 'cur' : '') },
      { t: 'Customs', s: events.length >= 4 ? 'done' : (events.length >= 3 ? 'cur' : '') },
      { t: 'Delivery', s: events.length >= 5 ? 'done' : (events.length >= 4 ? 'cur' : '') },
      { t: 'Delivered', s: isDelivered ? 'done' : '' }
    ];

    return {
      id: trackingNumber,
      product: 'Your Order',
      date: timeline.length > 0 ? timeline[timeline.length - 1].time : '',
      carrier: track.w1 || carrier || 'Carrier',
      track: trackingNumber,
      status: status,
      statusLabel: getStatusLabel(status),
      eta: eta,
      etaDays: etaDays,
      progress: Math.round(progress),
      progLabel: getStatusLabel(status),
      steps: steps,
      timeline: timeline.reverse(),
      alertType: status === 'exception' ? 'warn' : null,
      alertKey: status === 'exception' ? 'alert_customs' : null
    };
  }

  function formatEventTime(timestamp) {
    if (!timestamp) return '';
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  function getStatusLabel(status) {
    const labels = {
      pending: { en: 'Processing', de: 'In Bearbeitung', fr: 'En traitement', nl: 'In behandeling' },
      transit: { en: 'In Transit', de: 'Unterwegs', fr: 'En transit', nl: 'Onderweg' },
      customs: { en: 'Customs', de: 'Zoll', fr: 'Douane', nl: 'Douane' },
      delivered: { en: 'Delivered', de: 'Zugestellt', fr: 'Livré', nl: 'Bezorgd' },
      exception: { en: 'Action Required', de: 'Aktion erforderlich', fr: 'Action requise', nl: 'Actie vereist' },
      expired: { en: 'Expired', de: 'Abgelaufen', fr: 'Expiré', nl: 'Verlopen' },
      pickup: { en: 'Ready for Pickup', de: 'Abholbereit', fr: 'Prêt à retirer', nl: 'Klaar voor ophalen' },
      undelivered: { en: 'Undelivered', de: 'Nicht zugestellt', fr: 'Non livré', nl: 'Niet bezorgd' }
    };
    return labels[status] || labels.transit;
  }

  function simulateAPICall() {
    return new Promise(resolve => setTimeout(resolve, 1500));
  }

  function showError(form, message) {
    // Remove existing error
    const existing = form.querySelector('.form-error');
    if (existing) existing.remove();

    const error = document.createElement('div');
    error.className = 'form-error';
    error.style.cssText = 'color: var(--track-red); font-size: 13px; text-align: center; margin-top: 12px;';
    error.textContent = message;
    form.appendChild(error);

    setTimeout(() => error.remove(), 5000);
  }

  function showGuestResult(order) {
    const lookupCard = document.querySelector('.lookup-card');
    const guestHero = document.querySelector('.guest-hero');
    const resultView = document.querySelector('[data-guest-result]');
    const resultContainer = document.querySelector('[data-result-container]');

    if (lookupCard) lookupCard.style.display = 'none';
    if (guestHero) guestHero.style.display = 'none';
    if (resultView) resultView.style.display = 'block';

    if (resultContainer) {
      resultContainer.innerHTML = renderOrderCard(order);
      animateProgressBars();
    }
  }

  // ─── ORDER CARD RENDERING ────────────────────────────────────────────
  function renderOrderCard(order, options = {}) {
    const isDelivered = order.status === 'delivered';
    const isException = order.status === 'exception' || order.status === 'delayed';
    const highlightClass = options.highlight ? 'highlight' : '';
    const alertClass = isException ? 'alert-card' : '';
    const completedClass = isDelivered ? 'completed' : '';

    let footerLeft, footerRight;
    if (isDelivered) {
      footerLeft = `${tl(order.statusLabel)} · <a href="#">${t('leave_review')}</a> · <a href="#">${t('buy_again')}</a>`;
      footerRight = `<button class="btn-sm-outline">⬇ ${t('btn_invoice')}</button><button class="btn-sm-solid">${t('btn_reorder')}</button>`;
    } else if (isException) {
      footerLeft = `${t('help')} <a href="#">${t('contact_support')}</a>`;
      footerRight = `<button class="btn-sm-red">${t('btn_escalate')}</button><button class="btn-sm-solid">${t('btn_chat')}</button>`;
    } else {
      footerLeft = `${t('help')} <a href="#">${t('contact_support')}</a>`;
      footerRight = `<button class="btn-sm-outline">🔔 ${t('btn_notify')}</button><button class="btn-sm-solid">${t('btn_chat')}</button>`;
    }

    return `
    <div class="order-card ${highlightClass} ${alertClass} ${completedClass} fade-in">
      <div class="card-head">
        <div class="card-head-left">
          <div class="card-product">${order.product}</div>
          <div class="card-meta">${t('placed')} <strong>${order.id}</strong> · ${order.date} · ${order.carrier} <span class="tracking-num">${order.track}</span></div>
        </div>
        ${renderPill(order.status, order.statusLabel)}
      </div>
      ${renderAlertBanner(order)}
      ${renderSmartETA(order)}
      ${renderProgress(order)}
      <div class="card-divider"></div>
      ${renderTimeline(order.timeline, isDelivered && options.collapsible)}
      <div class="card-foot">
        <div class="card-foot-text">${footerLeft}</div>
        <div class="foot-actions">${footerRight}</div>
      </div>
    </div>`;
  }

  function renderPill(status, label) {
    return `<span class="pill ${status}"><span class="pill-dot"></span><span class="pill-text">${tl(label)}</span></span>`;
  }

  function renderAlertBanner(order) {
    if (!order.alertType) return '';
    const icons = { warn: '⚠️', error: '🚨', info: 'ℹ️' };
    return `
    <div class="card-alert ${order.alertType}">
      <div class="card-alert-icon">${icons[order.alertType]}</div>
      <div class="card-alert-body">${t(order.alertKey)}</div>
    </div>`;
  }

  function renderSmartETA(order) {
    if (order.status === 'delivered') return '';

    const isDelayed = order.etaDelayed;
    const bgClass = isDelayed ? 'delayed-bg' : '';
    let mainText, icon;

    if (order.etaDays === null) {
      icon = '⚠️';
      mainText = `<span class="countdown warn">${tl(order.statusLabel)}</span>`;
    } else if (order.etaDays === 0) {
      icon = '🎉';
      mainText = `<span class="countdown">${t('arriving_today')}</span>`;
    } else if (order.etaDays === 1) {
      icon = '📦';
      mainText = `<span class="countdown">${t('arriving_tomorrow')}</span>`;
    } else if (isDelayed) {
      icon = '⏳';
      mainText = `<span class="countdown warn">${t('delayed_warning')}${order.eta}</span>`;
    } else {
      icon = '🚚';
      mainText = `${t('est_delivery')}: <span class="countdown">${order.eta}</span> <span style="color:var(--track-ink4);font-weight:400">(${order.etaDays}${t('days_left')})</span>`;
    }

    return `
    <div class="smart-eta ${bgClass}">
      <div class="eta-icon">${icon}</div>
      <div class="eta-text">
        <div class="eta-main">${mainText}</div>
        <div class="eta-sub">${order.carrier} · ${order.track}</div>
      </div>
    </div>`;
  }

  function renderProgress(order) {
    let fillClass = '';
    if (order.progress === 100) fillClass = 'full';
    else if (order.status === 'delayed' || order.status === 'exception') fillClass = 'red';
    else if (order.status === 'customs') fillClass = 'amber';

    const stepsHTML = order.steps.map(s => `<div class="ps ${s.s}">${s.t}</div>`).join('');

    return `
    <div class="card-progress">
      <div class="prog-meta"><span>${tl(order.progLabel)}</span><span>${order.progress}%</span></div>
      <div class="prog-track"><div class="prog-fill ${fillClass}" style="width:0%;" data-width="${order.progress}"></div></div>
      <div class="prog-steps">${stepsHTML}</div>
    </div>`;
  }

  function renderTimeline(timeline, collapsed) {
    function renderItems(arr) {
      return arr.map((e, i, a) => {
        const isLast = i === a.length - 1;
        const titleClass = e.node === 'active' ? 'active' : (e.node === 'error' ? 'error' : (e.pending ? 'pend' : ''));
        let noteHTML = '';
        if (e.noteKey) noteHTML = `<div class="tl-note ${e.note || ''}">${t(e.noteKey)}</div>`;
        else if (e.noteText) noteHTML = `<div class="tl-note ${e.note || ''}">${tl(e.noteText)}</div>`;
        const locHTML = e.loc ? `<div class="tl-loc" style="${e.pending ? 'opacity:.4' : ''}">📍 ${e.loc}</div>` : '';
        const timeStyle = e.pending ? 'style="color:var(--track-border)"' : '';

        return `<div class="tl-item">${!isLast ? '<div class="tl-vline"></div>' : ''}<div class="tl-node ${e.node}">${e.icon}</div><div class="tl-body"><div class="tl-row"><span class="tl-title ${titleClass}">${tl(e.title)}</span><span class="tl-time" ${timeStyle}>${e.time}</span></div>${locHTML}${noteHTML}</div></div>`;
      }).join('');
    }

    if (!collapsed) {
      return `<div class="card-timeline">${renderItems(timeline)}</div>`;
    }

    // Collapsed: show last 2, hide the rest
    const visible = timeline.slice(-2);
    const hidden = timeline.slice(0, -2);
    const id = 'tl_' + Math.random().toString(36).slice(2);

    return `
    <div class="card-timeline">${renderItems(visible)}</div>
    <button class="collapse-toggle" onclick="window.XveloTracking.toggleCollapse('${id}')">
      <span id="${id}_label">${t('show_history')}</span>
    </button>
    <div class="collapse-content" id="${id}">
      <div class="card-timeline">${renderItems(hidden)}</div>
    </div>`;
  }

  function animateProgressBars() {
    setTimeout(() => {
      document.querySelectorAll('.prog-fill[data-width]').forEach(el => {
        const width = el.dataset.width;
        el.style.width = width + '%';
      });
    }, 100);
  }

  // ─── COLLAPSE TOGGLE ─────────────────────────────────────────────────
  function toggleCollapse(id) {
    const el = document.getElementById(id);
    const lbl = document.getElementById(id + '_label');
    if (!el || !lbl) return;

    const open = el.classList.toggle('open');
    lbl.textContent = open ? t('hide_history') : t('show_history');
  }

  // ─── DEMO DATA ───────────────────────────────────────────────────────
  function getDemoOrder() {
    return {
      id: '#XV-10293',
      product: 'Duotts C29 Mountain — Slate Grey',
      date: '26 Feb 2026',
      carrier: 'DHL Express',
      track: '1Z999AA10123456784',
      status: 'customs',
      statusLabel: { en: 'Customs Clearance', de: 'Zollabfertigung', fr: 'Dédouanement', nl: 'Douane' },
      eta: '6–7 March 2026',
      etaDays: 3,
      progress: 66,
      progLabel: { en: 'Customs clearance', de: 'Zollabfertigung', fr: 'Dédouanement', nl: 'Douane' },
      steps: [
        { t: 'Ordered', s: 'done' },
        { t: 'Shipped', s: 'done' },
        { t: 'Departed', s: 'done' },
        { t: 'Customs', s: 'cur' },
        { t: 'Delivery', s: '' },
        { t: 'Delivered', s: '' }
      ],
      timeline: [
        { node: 'done', icon: '✓', title: { en: 'Order confirmed', de: 'Bestellung bestätigt', fr: 'Commande confirmée', nl: 'Bestelling bevestigd' }, time: '26 Feb · 09:14', loc: 'Xvelo Warehouse, Shenzhen CN' },
        { node: 'done', icon: '✓', title: { en: 'Packed & collected by DHL', de: 'Verpackt & von DHL abgeholt', fr: 'Emballé & collecté par DHL', nl: 'Verpakt & opgehaald door DHL' }, time: '27 Feb · 14:32', loc: 'DHL Shenzhen Logistics Center' },
        { node: 'done', icon: '✓', title: { en: 'Departed — Hong Kong Airport', de: 'Abgereist — Hong Kong Flughafen', fr: 'Départ — Aéroport de Hong Kong', nl: 'Vertrokken — Hong Kong Airport' }, time: '28 Feb · 02:15', loc: 'HKG → FRA (cargo CX6050)' },
        { node: 'warn', icon: '⏳', title: { en: 'EU customs clearance — in progress', de: 'EU-Zollabfertigung — in Bearbeitung', fr: 'Dédouanement UE — en cours', nl: 'EU-douane — in behandeling' }, time: '1 Mar · 08:44', loc: 'DHL Hub, Frankfurt DE', note: 'warn', noteKey: 'alert_customs' },
        { node: 'pend', icon: '○', title: { en: 'Out for delivery', de: 'In Zustellung', fr: 'En cours de livraison', nl: 'Wordt bezorgd' }, time: 'Est. 6 Mar', loc: 'Amsterdam, NL', pending: true },
        { node: 'pend', icon: '○', title: { en: 'Delivered', de: 'Zugestellt', fr: 'Livré', nl: 'Bezorgd' }, time: 'Est. 6–7 Mar', pending: true }
      ]
    };
  }

  // ─── AUTHENTICATED VIEW ──────────────────────────────────────────────
  async function initAuthenticatedView() {
    const container = document.querySelector('[data-orders-container]');
    if (!container) return;

    // Check if we have real customer orders from Shopify
    const config = window.XveloTrackingConfig;
    if (config && config.isLoggedIn && config.orders) {
      await renderRealOrders(container, config.orders);
    } else {
      // No orders or not logged in
      container.innerHTML = `<div class="no-orders fade-in">
        <p>${t('loading_orders')}</p>
      </div>`;
    }
  }

  // Render real customer orders from Shopify
  async function renderRealOrders(container, shopifyOrders) {
    if (!shopifyOrders || shopifyOrders.length === 0) {
      container.innerHTML = `<div class="no-orders fade-in">
        <div style="text-align:center; padding: 40px 20px;">
          <div style="font-size: 48px; margin-bottom: 16px;">📦</div>
          <h3>No orders yet</h3>
          <p style="color: var(--track-ink3); margin: 12px 0 24px;">Start shopping to see your orders here!</p>
          <a href="/collections/all" class="btn-lg solid">Shop now</a>
        </div>
      </div>`;
      return;
    }

    // Convert Shopify orders to tracking format
    const orders = await Promise.all(shopifyOrders.map(async (shopifyOrder) => {
      return await convertShopifyOrderToTrackingAuth(shopifyOrder);
    }));

    renderAuthenticatedOrdersFromData(container, orders);
  }

  // Convert Shopify order for authenticated view
  async function convertShopifyOrderToTrackingAuth(shopifyOrder) {
    const fulfillment = shopifyOrder.fulfillments && shopifyOrder.fulfillments[0];
    const trackingNumber = fulfillment?.trackingNumber || fulfillment?.trackingNumbers?.[0];
    const carrier = fulfillment?.trackingCompany || 'Carrier';

    // Determine status
    let status = 'pending';
    if (shopifyOrder.fulfillmentStatus === 'fulfilled') {
      status = 'delivered';
    } else if (fulfillment) {
      status = 'transit';
    }

    // Try to get real tracking info if we have a tracking number
    if (trackingNumber && status !== 'delivered') {
      try {
        const response = await call17TrackAPI(trackingNumber);
        const trackingInfo = parseTrackingResponseSafe(response, trackingNumber, carrier);
        if (trackingInfo) {
          trackingInfo.id = shopifyOrder.name;
          trackingInfo.product = shopifyOrder.lineItems.map(i => i.title).join(', ');
          trackingInfo.date = shopifyOrder.createdAt;
          return trackingInfo;
        }
      } catch (e) {
        console.log('Could not fetch tracking for', trackingNumber);
      }
    }

    // Build basic order card
    const progress = status === 'delivered' ? 100 : (status === 'transit' ? 50 : 20);

    return {
      id: shopifyOrder.name,
      product: shopifyOrder.lineItems.map(i => i.title).join(', '),
      date: shopifyOrder.createdAt,
      carrier: carrier,
      track: trackingNumber || 'Processing',
      status: status,
      statusLabel: getStatusLabel(status),
      eta: '',
      etaDays: null,
      progress: progress,
      progLabel: getStatusLabel(status),
      steps: [
        { t: 'Ordered', s: 'done' },
        { t: 'Shipped', s: fulfillment ? 'done' : '' },
        { t: 'In Transit', s: status === 'transit' ? 'cur' : (status === 'delivered' ? 'done' : '') },
        { t: 'Delivered', s: status === 'delivered' ? 'done' : '' }
      ],
      timeline: [
        {
          node: 'done',
          icon: '✓',
          title: { en: 'Order placed', de: 'Bestellt', fr: 'Commande', nl: 'Besteld' },
          time: shopifyOrder.createdAt,
          loc: ''
        },
        ...(fulfillment ? [{
          node: status === 'delivered' ? 'done' : 'active',
          icon: status === 'delivered' ? '✓' : '📦',
          title: { en: `Shipped via ${carrier}`, de: `Via ${carrier}`, fr: `Via ${carrier}`, nl: `Via ${carrier}` },
          time: fulfillment.createdAt,
          loc: trackingNumber || ''
        }] : [])
      ]
    };
  }

  function renderAuthenticatedOrdersFromData(container, orders) {
    const activeOrders = orders.filter(o => o.status !== 'delivered');
    const deliveredOrders = orders.filter(o => o.status === 'delivered');

    let html = '';

    if (activeOrders.length > 0) {
      html += `<div class="sec-label fade-in">${t('active_ship')} <span class="badge">${activeOrders.length}</span></div>`;
      activeOrders.forEach(order => {
        html += renderOrderCard(order, { highlight: true });
      });
    }

    if (deliveredOrders.length > 0 && activeOrders.length > 0) {
      html += `<div class="sec-label fade-in" style="margin-top:28px">${t('order_history')} <span class="badge grey">${deliveredOrders.length}</span></div>`;
      deliveredOrders.forEach(order => {
        html += renderOrderCard(order, { collapsible: true });
      });
    } else if (deliveredOrders.length > 0 && activeOrders.length === 0) {
      html = renderAllDeliveredState(deliveredOrders);
    }

    if (html === '') {
      html = `<div class="no-orders fade-in">
        <div style="text-align:center; padding: 40px 20px;">
          <div style="font-size: 48px; margin-bottom: 16px;">📦</div>
          <h3>No active shipments</h3>
          <p style="color: var(--track-ink3);">All your orders have been delivered!</p>
        </div>
      </div>`;
    }

    container.innerHTML = html;

    const summary = document.querySelector('[data-orders-summary]');
    if (summary) {
      if (activeOrders.length > 0) {
        summary.textContent = `${activeOrders.length} ${t('active_ship').toLowerCase()}`;
      } else {
        summary.textContent = t('all_delivered_sub');
      }
    }

    animateProgressBars();
  }

  // Legacy function for demo data (kept for reference)
  function renderAuthenticatedOrders(container) {
    const orders = getDemoOrders();
    const activeOrders = orders.filter(o => o.status !== 'delivered');
    const deliveredOrders = orders.filter(o => o.status === 'delivered');

    let html = '';

    // Active orders section
    if (activeOrders.length > 0) {
      html += `<div class="sec-label fade-in">${t('active_ship')} <span class="badge">${activeOrders.length}</span></div>`;
      activeOrders.forEach(order => {
        html += renderOrderCard(order, { highlight: true });
      });
    }

    // Delivered orders section
    if (deliveredOrders.length > 0 && activeOrders.length > 0) {
      html += `<div class="sec-label fade-in" style="margin-top:28px">${t('order_history')} <span class="badge grey">${deliveredOrders.length}</span></div>`;
      deliveredOrders.forEach(order => {
        html += renderOrderCard(order, { collapsible: true });
      });
    } else if (deliveredOrders.length > 0 && activeOrders.length === 0) {
      // All delivered - show celebration
      html = renderAllDeliveredState(deliveredOrders);
    }

    container.innerHTML = html;

    // Update summary
    const summary = document.querySelector('[data-orders-summary]');
    if (summary) {
      if (activeOrders.length > 0) {
        summary.textContent = `${activeOrders.length} ${t('active_ship').toLowerCase()}`;
      } else {
        summary.textContent = t('all_delivered_sub');
      }
    }

    animateProgressBars();
  }

  function renderAllDeliveredState(deliveredOrders) {
    let html = `
    <div class="done-banner fade-in">
      <div class="done-icon">🎉</div>
      <div class="done-title">${t('all_delivered_title_1')}<em>${t('all_delivered_title_2')}</em></div>
      <div class="done-sub">${t('all_delivered_sub')}</div>
      <div class="done-actions">
        <a href="/collections/all" class="btn-lg solid">${t('shop_new')}</a>
        <a href="/collections/accessories" class="btn-lg outline">${t('view_acc')}</a>
      </div>
    </div>
    <div class="sec-label fade-in fade-in-d1">${t('order_history')} <span class="badge grey">${deliveredOrders.length}</span></div>`;

    deliveredOrders.forEach(order => {
      html += renderOrderCard(order, { collapsible: true });
    });

    return html;
  }

  function getDemoOrders() {
    return [
      getDemoOrder(),
      {
        id: '#XV-09817',
        product: 'Engwe Engine Pro — Midnight Black',
        date: '14 Feb 2026',
        carrier: 'DPD Europe',
        track: '05274190078735494',
        status: 'transit',
        statusLabel: { en: 'In Transit', de: 'Unterwegs', fr: 'En transit', nl: 'Onderweg' },
        eta: '4–5 March 2026',
        etaDays: 1,
        progress: 50,
        progLabel: { en: 'In transit to EU', de: 'Unterwegs zur EU', fr: 'En transit vers l\'UE', nl: 'Onderweg naar EU' },
        steps: [
          { t: 'Ordered', s: 'done' },
          { t: 'Shipped', s: 'done' },
          { t: 'Departed', s: 'cur' },
          { t: 'Customs', s: '' },
          { t: 'Delivery', s: '' },
          { t: 'Delivered', s: '' }
        ],
        timeline: [
          { node: 'done', icon: '✓', title: { en: 'Order confirmed', de: 'Bestellung bestätigt', fr: 'Commande confirmée', nl: 'Bestelling bevestigd' }, time: '14 Feb · 11:05', loc: 'Xvelo Warehouse, Shenzhen CN' },
          { node: 'done', icon: '✓', title: { en: 'Packed & collected by DPD', de: 'Verpackt & von DPD abgeholt', fr: 'Emballé & collecté par DPD', nl: 'Verpakt & opgehaald door DPD' }, time: '15 Feb · 16:20', loc: 'DPD Shenzhen Hub' },
          { node: 'active', icon: '✈️', title: { en: 'In transit — airborne', de: 'Unterwegs — in der Luft', fr: 'En transit — en vol', nl: 'Onderweg — in de lucht' }, time: '16 Feb · 03:40', loc: 'PVG → AMS', noteText: { en: 'Flight EK9202. Currently over Central Asia.', de: 'Flug EK9202. Derzeit über Zentralasien.', fr: 'Vol EK9202. Actuellement au-dessus de l\'Asie centrale.', nl: 'Vlucht EK9202. Momenteel boven Centraal-Azië.' } },
          { node: 'pend', icon: '○', title: { en: 'Arrived & customs', de: 'Angekommen & Zoll', fr: 'Arrivé & douane', nl: 'Aangekomen & douane' }, time: 'Est. 17 Feb', pending: true },
          { node: 'pend', icon: '○', title: { en: 'Out for delivery', de: 'In Zustellung', fr: 'En livraison', nl: 'Wordt bezorgd' }, time: 'Est. 4 Mar', pending: true },
          { node: 'pend', icon: '○', title: { en: 'Delivered', de: 'Zugestellt', fr: 'Livré', nl: 'Bezorgd' }, time: 'Est. 4–5 Mar', pending: true }
        ]
      }
    ];
  }

  // ─── INITIALIZE ──────────────────────────────────────────────────────
  function init() {
    currentLang = detectLanguage();
    updatePageLanguage();
    initLanguageSwitcher();
    initGuestForms();
    initAuthenticatedView();
  }

  // ─── EXPOSE GLOBAL API ───────────────────────────────────────────────
  window.XveloTracking = {
    toggleCollapse,
    setLanguage: (lang) => {
      if (i18n[lang]) {
        currentLang = lang;
        updatePageLanguage();
      }
    }
  };

  // ─── DOM READY ───────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
